import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef, useState } from 'react';
import { showApiErrorSnack } from '@/lib/show-api-error-snack';
import axiosClient from '../../actions/axios-client';

export function FileUpload({
  fileList,
  onFileUpload,
  onFileDelete,
  fullWidth = true,
  readOnly = false,
}) {
  const inputRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const uploadFile = (file) => {
    const headers = { 'Content-Type': file.type };
    axiosClient
      .post('/admin/image', file, { headers })
      .then((response) => {
        onFileUpload(response.data);
      })
      .catch((error) => {
        showApiErrorSnack(error, 'Image upload failed');
      });
  };

  const onInputChange = (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (file) {
      uploadFile(file);
    }
  };

  const first = fileList?.[0];
  const showThumb = Boolean(first?.url || first?.thumbUrl);

  return (
    <div
      className="clearfix festy-upload-root"
      style={{ width: fullWidth ? '100%' : 'auto' }}
    >
      {!readOnly && (
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={onInputChange}
        />
      )}
      {showThumb ? (
        <div className="festy-upload-tile relative inline-block align-top">
          <button
            type="button"
            className="border-none bg-transparent p-0"
            onClick={() => setPreviewUrl(first.url || first.thumbUrl)}
          >
            <img
              src={first.url || first.thumbUrl}
              alt=""
              className="max-h-[150px] max-w-[150px] object-contain"
            />
          </button>
          {!readOnly && (
            <button
              type="button"
              className="absolute right-1 top-1 rounded bg-black/55 px-2 py-1 text-xs text-white"
              onClick={() => onFileDelete?.()}
            >
              Remove
            </button>
          )}
        </div>
      ) : (
        !readOnly && (
          <button
            type="button"
            className="festy-upload-trigger festy-upload-tile inline-flex cursor-pointer flex-col items-center justify-center gap-1 border-none bg-[#fafafa] align-top text-[var(--primary)]"
            onClick={() => inputRef.current?.click()}
          >
            <FontAwesomeIcon icon={['fas', 'camera']} className="text-2xl" />
            <span className="text-sm">Upload</span>
          </button>
        )
      )}
      {previewUrl ? (
        <button
          type="button"
          className="bethere-modal-overlay fixed inset-0 flex cursor-default items-center justify-center border-none bg-black/70 p-4"
          onClick={() => setPreviewUrl(null)}
        >
          <img
            src={previewUrl}
            alt=""
            className="max-h-[90vh] max-w-full cursor-default object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </button>
      ) : null}
    </div>
  );
}
